import React from "react";

const ExpandedContext = React.createContext({
	expanded: "",
});

export { ExpandedContext };
